/**
 * @page loading store
 * @author
 * @Date 2018/7/2
 */

import { observable, action, configure, makeAutoObservable } from 'mobx';
import { Dialog } from '@ok/okd';

configure({
  enforceActions: 'always',
});

export default class loadingStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      loading: observable,
      showErrDialog: observable,
      errorMsg: observable,
      infoType: observable,
      accountShowLeftMenu: observable,
      showLoading: action,
      hideLoading: action,
      showErrorDialog: action,
      hideErrorDialog: action,
      setAccountShowLeftMenu: action,
    });

    this.rootStore = rootStore;
  }

  // 个人中心 或 资金管理 右侧内容区域加载状态
  loading = false;
  // 全局错误弹框展示标志

  showErrDialog = false;
  // 全局错误弹框错误信息
  errorMsg = '';
  // 信息类型  默认warn
  infoType = Dialog.Prompt.INFO_TYPE.warn; // error warn tip success

  accountShowLeftMenu = true;

  showLoading() {
    this.loading = true;
  }

  hideLoading() {
    this.loading = false;
  }

  showErrorDialog(errorMsg, infoType) {
    this.showErrDialog = true;
    this.errorMsg = errorMsg;
    this.infoType = infoType || Dialog.Prompt.INFO_TYPE.warn;
  }

  hideErrorDialog() {
    this.showErrDialog = false;
    this.errorMsg = '';
  }

  setAccountShowLeftMenu(value) {
    this.accountShowLeftMenu = value;
  }
}
